/**
 * amplitudeSettingsLink.ts — адрес подвкладки Amplitude в настройках проекта
 * и ключи подвкладок раздела «Аналитика и пиксели» (WEB-2413 п.9).
 *
 * ОДНА ПРАВДА НА ТРИ МЕСТА. Подвкладки раздела читают параметр адреса
 * (`AnalyticsIntegrationsTabs` → `useUrlSyncedTab`), плашка каркаса о поломке
 * (`AnalyticsDeliveryBanner`) ведёт на подвкладку Amplitude, письмо владельцу
 * (`ExternalAnalyticsMailService.integrationsLink` на сервере, WEB-2412 п.14)
 * ведёт туда же. Раньше плашка вела на `?tab=integrations` без подвкладки —
 * на «Рекламные сети», где Amplitude нет. Кабинетные концы берут ключи отсюда;
 * совпадение с письмом держит сторож
 * `__tests__/amplitudeSettingsLink.twoEnds.web2413.guard.test.ts`.
 */
import {
  ADS_SOON_NETWORKS,
  ANALYTICS_SOON_NETWORKS,
} from '@/components/capi/capiPixelCanon';

/** Путь страницы настроек проекта (`router/index.tsx`, `project/settings`). */
export const PROJECT_SETTINGS_PATH = '/project/settings';
/** Параметр вкладки страницы настроек (`ProjectSettings` → `useUrlSyncedTab('tab', …)`). */
export const PROJECT_SETTINGS_TAB_PARAM = 'tab';
/** Ключ вкладки «Аналитика и пиксели» (`PROJECT_SETTINGS_TABS`). */
export const INTEGRATIONS_TAB = 'integrations';

/**
 * Параметр подвкладки раздела и её ключи.
 *
 * WEB-3756 юнит 11: подвкладки — пункты списка слева: Meta, TikTok, Amplitude
 * (значение `analytics` прежнее — на него ведут письмо и плашка каркаса) и сети
 * «Скоро» из канона (`soon-<ключ>`). Старое значение `ads` (подвкладка
 * «Рекламные источники») читается как Meta — `normalizeAnalyticsSubtab`.
 */
export const ANALYTICS_SUBTAB_PARAM = 'sub';
/** Значение пункта сети «Скоро» в адресе. */
export function soonSubtab(key: string): string {
  return 'soon-' + key;
}
export const ANALYTICS_SUBTABS: readonly string[] = [
  'meta',
  'tiktok',
  'analytics',
  ...ADS_SOON_NETWORKS.map((n) => soonSubtab(n.key)),
  ...ANALYTICS_SOON_NETWORKS.map((n) => soonSubtab(n.key)),
];
/** Подвкладка, на которой живёт строка Amplitude. */
export const AMPLITUDE_SUBTAB = 'analytics';
/** Пункт по умолчанию — Meta. */
export const ANALYTICS_DEFAULT_SUBTAB = 'meta';
/** Старая подвкладка `ads` («Рекламные источники») — теперь пункт Meta. */
export function normalizeAnalyticsSubtab(raw: string): string {
  return raw === 'ads' ? ANALYTICS_DEFAULT_SUBTAB : raw;
}

/** Адрес подвкладки Amplitude текущего проекта. */
export function amplitudeSettingsRoute(): string {
  const params = new URLSearchParams({
    [PROJECT_SETTINGS_TAB_PARAM]: INTEGRATIONS_TAB,
    [ANALYTICS_SUBTAB_PARAM]: AMPLITUDE_SUBTAB,
  });
  return `${PROJECT_SETTINGS_PATH}?${params.toString()}`;
}
